import React from 'react';

import ChevronDown from 'components/Icons/ChevronDown';

import { NavItem } from '../interfaces';
import * as Styled from './styled';

export type ComponentProps = {
  /**
   * (Optional) the id of the selected navigation option. Defaults to ''
   */
  activeId: string;
  /**
   * The items to be displayed in the nav bar
   */
  items: NavItem[];
  /**
   * The action to be fired when a nav item is selected.
   * @param item selected menu item
   */
  onClick: (item: NavItem) => void;
};

const TopLevelNav: React.FC<ComponentProps> = ({ activeId, items, onClick }) => {
  return (
    <Styled.TopLevelNav role='navigation'>
      {items.map(item => {
        const { id, text } = item;
        const isActive = id === activeId;
        return (
          <Styled.NavItem key={id}>
            <Styled.NavLink
              isActive={isActive}
              onClick={() => onClick(item)}
              aria-expanded={isActive}>
              {text}
              <ChevronDown />
            </Styled.NavLink>
          </Styled.NavItem>
        );
      })}
    </Styled.TopLevelNav>
  );
};

export default React.memo(
  TopLevelNav,
  (prevProps, nextProps) =>
    prevProps.activeId === nextProps.activeId && prevProps.items === nextProps.items
);
